import {Component} from 'react';
import HomeInput from '../shared-components/home_input';
import HomeChangeModal from '../game-views/home_change_modal';
import InformationModal from '../shared-components/information_modal.js';
import { removeConditionsTable } from './objects/remove_Conditions_Table_function';
import { setupConditionsUpdate } from './objects/set_up_conditions_update_function';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { resetPicturesForChanges } from './objects/reset_pictureInfo_for_changes';
import { getHomePicture} from './objects/get_home_picture';
import { findRemoveTableItem } from '../../objects/AssetsExpenses/find_remove_table_item';
import { calcInflationAmt } from '../../objects/CommonUse/calc_inflation_amt';
import { calcMonthlyIncomeMinusHomeCosts } from './objects/calc_monthly_income_minus_home_costs';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { loanBalanceCalcFunction } from '../../objects/AssetsExpenses/loan_balance_calc_function';
import ConfigFile from '../../datasets/config_file';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';
import calculateShortTermSavings from './objectsHome/calculate_short_term_savings.js';

class HomeChange extends Component {
  
    constructor(props) {
        super(props);
        this.gameInfo = this.props.gameInfo();
        this.state = {
            openHomeChangeModal: false,
            headers: setHeadersForFetch(),
            subProcess: "homeChange",
            environment: Config.dataURL.currentEnv,
            previousHomeName: this.gameInfo.pictureInfo.homeName,
        }
        this.monthlyIncomeMinusRoommateAmts = 0;
        this.monthlyIncomeMinusHomeCosts = 0;
        this.conditionList = [];
        this.homeProfit = 0;
        this.loadProcess();
    }    
    
    loadProcess(){
        this.loadConditions();
        this.calcSavingsIncome();
    }
    
    loadConditions()
    {
        const funcName = "eventConditionsList";
        const urlParm = "?triggeredByList=monthly,homeChange";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,
            {method:'GET', headers: this.state.headers})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.conditionList = output.body;
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
        }
        });
    }

    calcSavingsIncome(){
        let homeType = this.gameInfo.gameData.conditionsTable.find(elem => 
                elem.condName === "homeType-apartment" || elem.condName === "homeType-house");
        this.homeProfit = 0;
          
        //  calculate monthly income that does not include any of the current housing
        //  costs 
        let monthlyIncomeObj = calcMonthlyIncomeMinusHomeCosts(homeType, 
            this.gameInfo.gameData.assetTable, this.gameInfo.gameData.expenseTable,
            this.gameInfo.gameData.loanTable);
        this.monthlyIncomeMinusRoommateAmtsAmts = +monthlyIncomeObj.monthlyIncomeMinusRoommateAmt;
        this.monthlyIncomeMinusHomeCosts = +monthlyIncomeObj.monthlyIncomeMinusHomeCosts;
        if (homeType.condName === "homeType-house"){
            this.determineProfitFromCurrentHome();
        }
        this.savings = (+this.gameInfo.gameData.currentCash + +this.homeProfit).toFixed(2);
        if (this.gameInfo.savingsInfo.gameID){
            const shortTermSavings = calculateShortTermSavings(this.gameInfo.savingsInfo);
            this.savings =  +this.savings + +shortTermSavings;
        }
    }

    determineProfitFromCurrentHome(){
        //  calculate profit from sale of current home - this increases the amount
        //  available for a down payment.
        let currentMortgageObj = findRemoveTableItem(this.gameInfo.gameData.loanTable,
             "mortgage", false);
        let nbrMonths = (currentMortgageObj.loanTerm * 12) - currentMortgageObj.loanNbrMonths;  
        let nbrYears = (+nbrMonths / 12).toFixed(0);       
        this.outstandingHomeAmt = +loanBalanceCalcFunction(currentMortgageObj.loanTotAmt,
            currentMortgageObj.loanIntRate, currentMortgageObj.loanAmt, currentMortgageObj.loanTerm,
            currentMortgageObj.loanNbrMonths);
        const currentPMIObj = findRemoveTableItem(this.gameInfo.gameData.loanTable, 'mortgagePMI', false);
        const outstandingPMIAmt = +loanBalanceCalcFunction(currentPMIObj.loanTotAmt,
            currentPMIObj.loanIntRate, currentPMIObj.loanAmt, currentPMIObj.loanTerm,
            currentPMIObj.loanNbrMonths);
        if (nbrYears > 0){
            this.currentHomeSellingPrice = +calcInflationAmt(currentMortgageObj.loanTotAmt,
                nbrYears)
        }else{
            this.currentHomeSellingPrice = +currentMortgageObj.loanTotAmt;
        }
        this.outstandintHomeAmt += +outstandingPMIAmt;
        this.homeProfit = (this.currentHomeSellingPrice - this.outstandingHomeAmt).toFixed(2);
    }

    onHomeSelected() {
      //  this.newRentAmt = sessionStorage.getItem("homeCost");
      //  this.newRoommates = sessionStorage.getItem("homeRoommates");
      //  this.newBedrooms = sessionStorage.getItem("homeBedrooms");
      //  this.newHomeName= sessionStorage.getItem("homeName");
        this.setState({openHomeChangeModal: true});
    }

    render() {
        this.gameStarted = true;
         
    return <>
            
            {this.state.openHomeChangeModal ?
                <HomeChangeModal show={this.state.openHomeChangeModal} 
                    homeProfit={this.homeProfit}
                    currentHomeSellingPrice={this.currentHomeSellingPrice}
                    currentLoanOutstandingAmt={this.outstandingHomeAmt}
                    monthlyIncomeMinusRoommateAmts={this.monthlyIncomeMinusRoommateAmtsAmts}
                    monthlyIncomeMinusHomeCosts={this.monthlyIncomeMinusHomeCosts}
                    gameInfo = {() => this.props.gameInfo()}
                    setGameInfo = {(value, propertyName) => 
                            this.props.setGameInfo(value, propertyName)}
                    onAlert={() => this.openInformationModal()}
                    onClose={() => this.closeHomeChangeModal()} 
                    onCancel={() => this.cancelHomeChange()}
                    onConfirmHomeChange={() => this.onConfirmHomeChange()}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                />
            :
                <div></div>
            }
            {this.state.openInformationModal ?
                <InformationModal
                    show={this.openInformationModal}
                    infoCode = {this.informationCode}
                    onClose = {() => this.closeInformationModal}
                />
            :
                null
            }
            <HomeInput onSelected={() => this.onHomeSelected()}
                gameStarted = {this.gameStarted}
                currentGameDate = {this.gameInfo.gameData.currentGameDate}
                startGameDate = {this.gameInfo.gameData.startGameDate}
                nbrBedrooms={this.gameInfo.gameData.homeInfo.bedrooms}
                nbrRoommates={this.gameInfo.gameData.homeInfo.roommates}
                currentHomeID={this.gameInfo.gameData.homeInfo.homeID}
                savings = {this.savings}
                monthlyIncome={this.monthlyIncomeMinusHomeCosts}
                homeName={this.gameInfo.pictureInfo.homeName}
                processError = {(errorObj) => this.props.processError(errorObj)}
            /> 
      </>
    }

    sendAlert(){
        this.informationCode = "HomeSame";
        this.setState({openHomeChangeModal: false, openInformationModal: true});
    }

    closeInformationModal(){
        this.setState({openInformationModal: false});
    }
   
    closeHomeChangeModal() {
        this.setState({openHomeChangeModal: false});
    }
    
    cancelHomeChange() {
        this.setState({openHomeChangeModal: false});
        this.props.onNavigate("game-board");
    }

    onConfirmHomeChange() {
        this.setState({openHomeChangeModal: false});
        this.getSessionStorage();
        this.updateConditionTable();
        if (ConfigFile.general.eventTracker === true){
            this.saveEventTracker();
        }
        this.setBodyObj();
        this.updateHomeInfo();
        this.props.setGameInfo(this.gameInfo.gameData, 'gameData');
        this.props.setGameInfo(0, "homeChangeNbrMonths");
        this.updatePictureInfo();
       
        sessionStorage.removeItem("ChangeHomeDepositRefund");
        sessionStorage.removeItem("homeChangeType");
        this.props.onChangeComplete();
        this.props.onNavigate("status-display");
    }

    getSessionStorage(){
        this.newCashAmt = sessionStorage.getItem("changeHomeNewCashAmt");
        this.chgCashAmt = (this.gameInfo.gameData.currentCash - +this.newCashAmt) * -1;
        this.newHomeId = sessionStorage.getItem("homeChoice");
        this.newHomeType = sessionStorage.getItem("homeType");
        this.newRoommates= sessionStorage.getItem("homeRoommates");
        this.newBedrooms = sessionStorage.getItem("homeBedrooms");
        this.newAssetTable = JSON.parse(sessionStorage.getItem("changeHomeAssetObjects"));
        this.newExpenseTable = JSON.parse(sessionStorage.getItem("changeHomeExpenseObjects"));
        this.newLoanTable = JSON.parse(sessionStorage.getItem("changeHomeLoanObjects"));
        this.moodPointChange = sessionStorage.getItem("homeChangeMoodPoints");
    }

    setBodyObj(){
       
        this.gameInfo.gameData.currentCash = this.newCashAmt;
      
        this.gameInfo.gameData.assetTable = this.newAssetTable;
        this.gameInfo.gameData.expenseTable = this.newExpenseTable;
        this.gameInfo.gameData.loanTable = this.newLoanTable;
        this.gameInfo.gameData.currentMoodPoints = +this.gameInfo.gameData.currentMoodPoints +
            +this.moodPointChange;
        let newIconTable = this.gameInfo.gameData.iconTable;
        let startIdx = newIconTable.length - 1;
        for (let i=startIdx; i>=0; i--){
            if (newIconTable[i].iconName === "purchaseAHome"  ){
               newIconTable.splice(i,1);
               break;
            }
        }
        this.gameInfo.gameData.conditionsTable = this.conditionsTable;
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        this.bodyObj = {
            "cash": this.newCashAmt, 
            "homeInfo": this.gameInfo.gameData.homeInfo, 
            "assetTable": this.newAssetTable,
            "expenseTable": this.newExpenseTable,
            "loanTable": this.newLoanTable,
            "iconTable": newIconTable,
            "conditionsTable": this.conditionsTable,
            "currentMoodPoints": this.gameInfo.gameData.currentMoodPoints,
        }
    }

    updateConditionTable(){
        this.conditionsTable = removeConditionsTable(this.gameInfo.gameData.conditionsTable, "home");
        const newHomeInfo = {homeID: this.newHomeId, homeType: this.newHomeType,
            roommates: this.newRoommates, bedrooms: this.newBedrooms};
        this.gameInfo.gameData.homeInfo = newHomeInfo;
        let conditionClasses = ["home", "roommate"];
        let newHomeConditionsTable = 
            setupConditionsUpdate(this.gameInfo.gameData, this.conditionList, conditionClasses);
        for (let i=0; i<newHomeConditionsTable.length; i++){
            this.conditionsTable.push(newHomeConditionsTable[i]);
        }
    }
          
    updateHomeInfo()
    {  
        const funcName = "updateHomeInfo";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'PUT', headers: this.state.headers, 
        body: JSON.stringify(this.bodyObj)})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        //  successful update of gameData
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
    }
    
    updatePictureInfo(){
        let homeChangeType = sessionStorage.getItem("homeChangeType");
        if (homeChangeType && homeChangeType === "roommate-change"){
             let homeDesc = sessionStorage.getItem("homeDesc");
             this.gameInfo.pictureInfo.homeName = homeDesc;
        }else{
            let homeID = sessionStorage.getItem("homeChoice");
            let homeDesc = sessionStorage.getItem("homeDesc");
            let homeDirectory = sessionStorage.getItem("homeDirectory");
            let homePictureImg = './assets/' + homeDirectory + "/default.jpg";
            let additionalPhotosArr = JSON.parse(sessionStorage.getItem("homeAdditionalPhotosArr"));
            let livingRoomImg = getHomePicture(homeDirectory, additionalPhotosArr, "Living Room");
            this.gameInfo.pictureInfo = resetPicturesForChanges("home", this.gameInfo.pictureInfo,    
                homeID, homeDesc, homePictureImg, livingRoomImg);
            this.props.setGameInfo(this.gameInfo.pictureInfo, 'pictureInfo');
        }
    }
   
    saveEventTracker(){
        const homeName = sessionStorage.getItem("homeDesc");
        let cashChange = this.chgCashAmt.toFixed(2);
        cashChange = cashChange.toString();
        const homeChangeInfo = {changeMade: "home", previous: this.state.previousHomeName, new: homeName,
            cashChg: cashChange,
            conditionTable: this.conditionsTable,
            assetTable: this.newAssetTable, 
            expenseTable: this.newExpenseTable,
            loanTable: this.newLoanTable, 
            moodPoints: this.moodPointChange};
        const dataObject = createEventTrackerUpdateObject("ChangeGameChoices", "HomeChange",
            this.gameInfo.gameData, homeChangeInfo, this.gameInfo.creditCardInfo);
        const funcName = "saveEventTracker";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            {
            method:'post',
            headers: this.state.headers,
            body: JSON.stringify(dataObject)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                           // save of event tracker was successful in homeChange
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: dataObject};
                            this.props.processError(errorObj);
                        }
                    });
                };
        });
    }
        
}

export default HomeChange;